import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';

const PaymentExpiredSummary = () => (
    <StatusSummaryButton
        href="/start-trygg-betaling"
        statusSummary="Betalingsfristen har gått ut."
        actionRequiredType="NEGATIVE"
    >
        Send et nytt avtaleforslag
    </StatusSummaryButton>
);

export default PaymentExpiredSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/payment/summaries/paymentExpiredSummary.jsx